<template>
	<v-alert type="error" dismissible prominent v-if="hasErrors">
		{{ $t("title.something_went_wrong") }}
		<ul>
			<li v-for="(error, key) in errors" :key="key">{{ error }}</li>
		</ul>
	</v-alert>
</template>

<script>
export default {
	computed: {
		errors() {
			return this.$page.props.errors;
		},

		hasErrors() {
			return this.errors?.length > 0;
		},
	},
};
</script>
